import { useAuth0 } from "@auth0/auth0-react";
import Action from "components/ActionPopOver";
import AlertDialog from "components/Dialog";
import MyTable from "components/Table";
import { searchRequest } from "hook/searchRequest";
import FinanceService from "Lib/API/Finance";
import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router";
import "../index.scss";

const DeactivatProducts = ({ refresh, subValue, setRefresh,searchText }) => {
  const [loading, setLoading] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [list, setList] = React.useState([]);
  const [table, setTable] = React.useState([]);
  const [deleteClicked, setDeleteClicked] = useState(false);
  const [productId, setProductId] = React.useState("");

  const rowsPerPage = 15;
  const { getAccessTokenSilently } = useAuth0();
  const history = useHistory();
  const handleCloseDialog = () => {
    setOpenAlert(false);
  };
  const handleDelete = async () => {
    const token = await getAccessTokenSilently();
    await FinanceService.removeProduct({ product_id: productId }, token)
      .then((res) => {
        if (res) {
          setOpenAlert(false);
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);

      });
  };
  const handleChange = async () => {
    const token = await getAccessTokenSilently();
    await FinanceService.updateProduct(
      { product_id: productId, activated: true },
      token
    )
      .then((res) => {
        if (res) {
          setOpenAlert(false);
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);

      });
  };
  const enableLoading = (value) => {
    setLoading(value);
  };

  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      const idLength = history.location.pathname?.split("/").length;
      const id = history?.location?.pathname?.split("/")[idLength - 1];
      if (id === "1")
        await FinanceService.getFilteredProducts("filter?active=false", token)
          .then((res) => {
            if (res.length) {
              res.map((item) => {
                item.id = item._id;
                return item;
              });
              setList(res);
              setTable(res);
            } else setList([]);
            enableLoading(false);
          })
          .catch((err) => {
            enableLoading(false);
            toastr.error("Error", err?.data?.message);

          });
      else {
        if (history?.location?.state) {
          await FinanceService.getProductsBySubCat("?active=false", id, token)
            .then((res) => {
              if (res.length) {
                res.map((item) => {
                  item.id = item._id;
                  return item;
                });
                setList(res);
                setTable(res);
              } else setList([]);
              enableLoading(false);
            })
            .catch((err) => {
              enableLoading(false);
              toastr.error("Error", err?.data?.message);
            });
        } else
          await FinanceService.getProductsByLedgerAccount(
            "?active=false",
            id,
            token
          )
            .then((res) => {
              if (res.length) {
                res.map((item) => {
                  item.id = item._id;
                  return item;
                });
                setList(res);
                setTable(res);
              } else setList([]);
              enableLoading(false);
            })
            .catch((err) => {
              enableLoading(false);
              toastr.error("Error", err?.data?.message);
            });
      }
    }
    fetchMyAPI();
    enableLoading(true);
  }, [getAccessTokenSilently, history, refresh, subValue]);
  const columns = [
    {
      field: "prod_id",
      resizable: true,
      headerName: "ID",
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (data) => {
        return <div style={{ fontSize: "14px" }}>{data?.row?.prod_id}</div>;
      },
    },
    {
      field: "prod_name",
      resizable: true,
      headerName: "PRODUCT NAME",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => {
        return (
          <div style={{ fontSize: "14px", color: "grey" }}>
            {" "}
            {data?.row?.prod_name}
          </div>
        );
      },
    },
    {
      field: "description",
      resizable: true,
      headerName: "DESCRIPTION",
      minWidth: 250,
      sortable: false,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "grey" }}>
          {data?.row?.description}
        </div>
      ),
    },
    {
      field: "year",
      resizable: true,
      headerName: "YEAR",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px" }}>{data?.row?.year}</div>
      ),
    },
    {
      field: "price",
      resizable: true,
      headerName: "PRICE",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#4fb152" }}>
          {data?.row?.price}
        </div>
      ),
    },
    {
      field: "action",
      resizable: true,
      headerName: `${" "}`,
      sortable: false,
      minWidth: 15,
      renderCell: () => (
        <div style={{ cursor: "pointer" }}>
          <Action
            onDeleteClick={() => {
              setOpenAlert(true);
              setDeleteClicked(true);
            }}
            onActiveClick={() => {
              setOpenAlert(true);
            }}
          />
        </div>
      ),
    },
  ];
  React.useEffect(() => {
    searchRequest(searchText, table, setList);
  }, [searchText]);

  return (
    <div className="activated-ledger">
      <div className="ledger-table" style={{ height: "fit-content" }}>
        <div className="table-title">
          {/* {list[0]?.led_account?.led_acc_name} */}
        </div>
        <div className="home-table-container mt-0">
          <MyTable
            className="family-table"
            rows={list}
            columns={columns}
            pageSize={6}
            loading={loading}
            rowHeight={65}
            onClickEvent={(params, event) => {
              event.defaultMuiPrevented = true;
              setProductId(params?.row?._id);
            }}
          >
            Rows per page: {rowsPerPage}
          </MyTable>
          <AlertDialog
            open={openAlert}
            handleClose={handleCloseDialog}
            onDecline={() => {
              setOpenAlert(false);
            }}
            I={() => {
              deleteClicked ? handleDelete() : handleChange();
            }}
            title={"Are you sure?"}
          />
        </div>
      </div>
    </div>
  );
};

export default DeactivatProducts;
